import { render, staticRenderFns } from "./gerenPaciente.vue?vue&type=template&id=bf68bc6c&scoped=true&"
import script from "./gerenPaciente.vue?vue&type=script&lang=js&"
export * from "./gerenPaciente.vue?vue&type=script&lang=js&"
import style0 from "./gerenPaciente.vue?vue&type=style&index=0&id=bf68bc6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf68bc6c",
  null
  
)

export default component.exports